// Paleta determinística para avatares — 12 colores diseñados para contraste con texto blanco (WCAG AA >= 4.5:1).
// Sin --color-primary (#ff0000) porque colisiona con la semántica destructiva.
export const AVATAR_PALETTE = [
  '#0d3b70', // navy
  '#7c2d12', // rust
  '#166534', // forest
  '#7e22ce', // purple
  '#0e7490', // teal
  '#9f1239', // crimson
  '#1d4ed8', // royal blue
  '#15803d', // emerald
  '#a16207', // amber
  '#be185d', // pink
  '#374151', // graphite
  '#4338ca', // indigo
] as const;

export type AvatarColor = (typeof AVATAR_PALETTE)[number];
